import React, { useContext } from 'react';
import { type InteractionLogEntry } from '../../../types/interaction-log-data';
import { LogViewer } from '../log-viewer';
import { type LogItemProps } from '../log-viewer/log-item';
import { formatTime } from '../../../utils/format';
import { EventIcon } from './event-icon';
import { getIndentLevel } from './utils';
import { getParametersForEventType } from './parameter-selector';
import { LogType } from '../../../types/visualizer';
import { useConfigurationContext } from '../../../contexts/configuration-context';
import { AuthContext } from '@@/contexts/AuthContext';

export const IvrLogViewer = (props: { logs?: InteractionLogEntry[] }) => {
  const { instanceData } = useContext(AuthContext);
  const configuration = useConfigurationContext();

  if (!props.logs || props.logs.length === 0) {
    return (
      <div className='flex items-center justify-center h-full text-neutral-500'>No interaction logs available</div>
    );
  }

  const logItems: LogItemProps[] = props.logs.map((log, index) => ({
    timestamp: formatTime(log.AbsoluteTime),
    title: log.EventType,
    subtitle: log.LogData.ResourceName && getIndentLevel(log) === 0 ? log.LogData.ResourceName : undefined,
    content: log.LogData.Content,
    parameters: getParametersForEventType(log),
    status:
      log.LogData.Action?.ExecutionResult && log.EventType === 'ExecutionResult'
        ? log.LogData.Action.ExecutionResult
        : undefined,
    identifier: log.LogData.Action?.Identifier,
    icon: <EventIcon eventType={log.EventType} />,
    indentLevel: getIndentLevel(log),
    raw: log,
    index: index,
    accountId: instanceData?.awsAccountId ?? '',
    instanceAlias: configuration.connect.instanceAlias
  }));

  return <LogViewer logs={logItems} logType={LogType.INTERACTION_LOG} emptyMessage='No interaction logs available' />;
};
